import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.32_@babel+core@7.28.5_@playwright+test@1.56.1_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/_components/SocialButton/SocialButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(authenticated)/(member)/_components/Avatar/Avatar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(authenticated)/(member)/_components/CV/_components/NeedHelp/NeedHelpBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProudOf"] */ "/vercel/path0/src/app/(authenticated)/(member)/_components/CV/_components/ProudOf.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MemberPublicHeader","CVHeaderHeader"] */ "/vercel/path0/src/app/(authenticated)/(member)/members/[id]/_components/CVHeaderHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/TruncateText/TruncateText.tsx");
